import { createSlice } from '@reduxjs/toolkit';
import { getDataFromLocalStorage, storeLocalStorageData } from 'utils/helpers';
import {
  handelResponse,
  handelCatch,
  unsetSessionExpired,
  setIsLogout,
  fetchProfile,
  setShowUnsubscribedPopup,
  throwError,
} from 'store/slices';
import { api } from 'services';

const initialState = { userData: {}, speakeRegisterData: {}, tempUserData: '' };
const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    storeUserData(state, action) {
      state.userData = action.payload;
    },
    storeSpeakeregisterData(state, action) {
      state.speakeRegisterData = action.payload;
    },
    removeUserData(state) {
      state.userData = {};
    },
    setTempUserData(state, action) {
      state.tempUserData = action.payload;
    },
  },
});

export const { storeUserData, removeUserData, storeSpeakeregisterData } =
  authSlice.actions;
export const handelLogin = (credentials) => async (dispatch) => {
  try {
    const res = await api.post('/login', credentials, {});
    const responseData = await dispatch(handelResponse(res));
    if (responseData?.status === 200) {
      storeLocalStorageData(responseData?.data);
      dispatch(storeUserData(responseData?.data));
    }
    return responseData;
  } catch (error) {
    return dispatch(handelCatch(error));
  }
};
export const handelMemberLogin = (credentials) => async (dispatch) => {
  try {
    const res = await api.post('/dashboard/login', credentials, {});
    const responseData = await dispatch(handelResponse(res));
    if (responseData?.status === 200) {
      if (responseData?.data?.user_type === '1') {
        dispatch(
          handelCatch({
            response: {
              status: 400,
              data: { message: 'Something wrong with this login credential!' },
            },
          })
        );
      } else {
        storeLocalStorageData(responseData?.data);
        dispatch(storeUserData(responseData?.data));
      }
    }
    return responseData;
  } catch (error) {
    return dispatch(handelCatch(error));
  }
};
export const handelRegister = (credentials) => async (dispatch) => {
  try {
    const res = await api.post('/dashboard/register', credentials, {});
    const responseData = await dispatch(handelResponse(res));
    if (responseData?.status === 200) {
      storeLocalStorageData(responseData?.data);
      dispatch(storeUserData(responseData?.data));
    }
    return responseData;
  } catch (error) {
    return dispatch(handelCatch(error));
  }
};

// -----Speaker Registration-----
export const speakerRegistration = (credentials) => async (dispatch) => {
  try {
    const res = await api.post('/sepkaer-registration', credentials, {});
    const responseData = await dispatch(handelResponse(res));
    if (responseData?.status === 200) {
      storeLocalStorageData(responseData?.data);
      dispatch(storeUserData(responseData?.data));
    }
    return responseData;
  } catch (error) {
    return dispatch(handelCatch(error));
  }
};
//storeSpeakeregisterData
export const speakeregisterData = (userData) => async (dispatch) => {
  try {
    dispatch(storeSpeakeregisterData(userData));
  } catch (error) {
    return dispatch(handelCatch(error));
  }
};

//verify-email-send
export const handelSpeakerEmailVerify = (credentials) => async (dispatch) => {
  try {
    const res = await api.post('/dashboard/verify-email-send', credentials, {});
    // return await dispatch(handelResponse(res));
    const responseData = await dispatch(handelResponse(res));
    // if (responseData?.status === 200) {
    //   storeLocalStorageData(responseData?.data);
    //   dispatch(storeUserData(responseData?.data));
    // }
    return responseData;
  } catch (error) {
    return dispatch(handelCatch(error));
  }
};
export const handelSendOTP = (credentials) => async (dispatch) => {
  try {
    const res = await api.post('/dashboard/resend-otp', credentials, {});
    return await dispatch(handelResponse(res));
  } catch (error) {
    return dispatch(handelCatch(error));
  }
};
export const handelUserRegisterDetails = (credentials) => async (dispatch) => {
  try {
    const res = await api.post('/user/registration-details', credentials, {});
    const responseData = await dispatch(handelResponse(res));
    if (responseData?.status === 200) {
      let oldData = getDataFromLocalStorage();
      oldData = {
        ...oldData,
        registration_status: responseData?.data?.registration_status,
      };
      storeLocalStorageData(oldData);
    }
    return responseData;
  } catch (error) {
    return dispatch(handelCatch(error));
  }
};

//update address and pincode
export const updateAddressDetails = (formData) => async (dispatch) => {
  try {
    const res = await api.post(
      '/user/profile/update-user-address-info',
      formData
    );
    return await dispatch(handelResponse(res));
  } catch (error) {
    return dispatch(handelCatch(error));
  }
};

// membership confirmation page (#1489)
export const fetchMembershipConfirmation = () => async (dispatch) => {
  try {
    const res = await api.get('/user/membership-confirmation');
    return await dispatch(handelResponse(res));
  } catch (error) {
    return dispatch(handelCatch(error));
  }
};
// sendError() answers with HTTP 200 and a JSON body, so a blob is not proof of a
// PDF: surface the message instead of saving a broken file.
const downloadPdf = async (dispatch, url, fallbackMessage) => {
  try {
    const file = await api.getFile(url);
    if (file?.type?.includes('json')) {
      const { message } = JSON.parse(await file.text());
      dispatch(throwError({ message: message || fallbackMessage }));
      return null;
    }
    return file;
  } catch (error) {
    dispatch(throwError({ message: fallbackMessage }));
    return null;
  }
};

export const downloadMembershipReceipt = () => async (dispatch) =>
  downloadPdf(
    dispatch,
    '/user/membership-receipt',
    'Could not download the receipt. Please try again.'
  );
// Lifetime members get the lifetime certificate (#1080) instead of the premium
// membership certificate produced by the external generator.
export const downloadLifetimeCertificate = () => async (dispatch) =>
  downloadPdf(
    dispatch,
    '/user/lifetime-membership-certificate',
    'Could not download the membership certificate. Please try again.'
  );
export const fetchFreeVsPremium = () => async (dispatch) => {
  try {
    const res = await api.get('/user/membership-free-vs-premium');
    return await dispatch(handelResponse(res));
  } catch (error) {
    return dispatch(handelCatch(error));
  }
};
export const fetchEmailVerificationStatus = () => async (dispatch) => {
  try {
    const res = await api.get('/user/email-verification-status');
    return await dispatch(handelResponse(res));
  } catch (error) {
    return dispatch(handelCatch(error));
  }
};
export const fetchUserDetails = () => async (dispatch) => {
  try {
    const res = await api.get('/user/profile/details');
    const responseData = await dispatch(handelResponse(res));
    return responseData;
  } catch (error) {
    return dispatch(handelCatch(error));
  }
};
export const getMembershipDetails = (formData) => async (dispatch) => {
  try {
    const res = await api.post('/dashboard/get-membership-benefits', formData);
    return await dispatch(handelResponse(res));
  } catch (error) {
    return dispatch(handelCatch(error));
  }
};
export const editMembership = (formData) => async (dispatch) => {
  try {
    const res = await api.post('/user/membership-pay', formData);
    const responseData = await dispatch(handelResponse(res));

    if (responseData?.status === 200) {
      let oldData = getDataFromLocalStorage();
      oldData = {
        ...oldData,
        registration_status: '4',
      };
      storeLocalStorageData(oldData);
    }
    return responseData;
  } catch (error) {
    return dispatch(handelCatch(error));
  }
};
export const changePassword = (formData) => async (dispatch) => {
  try {
    const res = await api.post('/user/change-password', formData);
    return await dispatch(handelResponse(res));
  } catch (error) {
    return dispatch(handelCatch(error));
  }
};
export const forgotPassword = (formData) => async (dispatch) => {
  try {
    const res = await api.post('/dashboard/forgot-password', formData);
    return await dispatch(handelResponse(res));
  } catch (error) {
    return dispatch(handelCatch(error));
  }
};
export const verifyOTP = (formData) => async (dispatch) => {
  try {
    const res = await api.post('/dashboard/register-verify-otp', formData);
    return await dispatch(handelResponse(res));
  } catch (error) {
    return dispatch(handelCatch(error));
  }
};

//campaign send OTP
export const sendOTP = (formData) => async (dispatch) => {
  try {
    const res = await api.post('/send-campaign-otp', formData);
    return await dispatch(handelResponse(res));
  } catch (error) {
    return dispatch(handelCatch(error));
  }
};

//campaign verify OTP
export const campaignVerifyOTP = (formData) => async (dispatch) => {
  try {
    const res = await api.post('/verify-campaign-otp', formData);
    const responseData = await dispatch(handelResponse(res));

    if (responseData?.status === 200) {
      if (responseData?.data?.user_type === '1') {
        dispatch(
          handelCatch({
            response: {
              status: 400,
              data: { message: 'Something wrong with this login credential!' },
            },
          })
        );
      } else {
        localStorage.IsNavigateProfile = 1;
        storeLocalStorageData(responseData?.data);
        await dispatch(fetchProfile());

        dispatch(storeUserData(responseData?.data));
      }
    }

    return responseData;
  } catch (error) {
    return dispatch(handelCatch(error));
  }
};

//unsubscribe email
export const unSubscribeEmail = (formData) => async (dispatch) => {
  try {
    const res = await api.post('/update-subscribe-status', formData);
    const responseData = dispatch(handelResponse(res));
    if (responseData?.status === 200) {
      dispatch(unsetSessionExpired());
      setTimeout(() => {
        dispatch(setShowUnsubscribedPopup(true));
      }, 500);
    } else {
      dispatch(unsetSessionExpired());
      setTimeout(() => {
        dispatch(setShowUnsubscribedPopup(true));
      }, 500);
    }

    return responseData;
  } catch (error) {
    return dispatch(setShowUnsubscribedPopup(true));
  }
};

export const logoutAPI = (formData) => async (dispatch) => {
  try {
    const res = await api.post('/user/logout', formData);
    return await dispatch(handelResponse(res));
  } catch (error) {
    return dispatch(handelCatch(error));
  }
};

export const handelLogout = () => async (dispatch) => {
  localStorage.clear();
  // caches?.keys().then((names) => {
  //   names.forEach((name) => {
  //     caches?.delete(name);
  //   });
  // });
  dispatch(removeUserData());
  dispatch(unsetSessionExpired());
  dispatch(setIsLogout(false));
};

//new password for temp user
export const updatePasswordTempUser = (formData) => async (dispatch) => {
  try {
    const res = await api.post('/dashboard/store-new-password', formData);
    const responseData = await dispatch(handelResponse(res));
    if (responseData?.status === 200) {
      storeLocalStorageData(responseData?.data);
      dispatch(storeUserData(responseData?.data));
    }
    return responseData;
  } catch (error) {
    return dispatch(handelCatch(error));
  }
};

export const sendForgotPasswordLink = (formData) => async (dispatch) => {
  try {
    const res = await api.post(
      '/dashboard/send-forgot-password-link',
      formData
    );
    return await dispatch(handelResponse(res));
  } catch (error) {
    return dispatch(handelCatch(error));
  }
};

export const verifyForgotPasswordLink = (formData) => async (dispatch) => {
  try {
    const res = await api.post(
      '/dashboard/verify-forgot-password-link',
      formData
    );
    return await dispatch(handelResponse(res));
  } catch (error) {
    return dispatch(handelCatch(error));
  }
};

export const fetchProfessionalDetails = () => async (dispatch) => {
  try {
    const res = await api.get('/user/get-professional-experiences');
    const responseData = await dispatch(handelResponse(res));
    return responseData;
  } catch (error) {
    return dispatch(handelCatch(error));
  }
};

export const handelProfessionalDetails = (payload) => async (dispatch) => {
  try {
    const res = await api.post(
      '/user/store-professional-experiences',
      payload,
    );
    return await dispatch(handelResponse(res));
  } catch (error) {
    return dispatch(handelCatch(error));
  }
};

export const { setTempUserData } = authSlice.actions;
export default authSlice.reducer;
